<template>
	<div class="web-player-feedback">
		<div class="web-player-feedback__align">
			<div v-if="!requirePassword && !title && !message" class="stream-loader">
				<div class="ui-progress-dots">
					<div class="bounce1"></div>
					<div class="bounce2"></div>
					<div class="bounce3"></div>
				</div>
			</div>
			<div v-else class="stream-feedback">
				<h1 class="ui-headline">{{ title }}</h1>
				<h2 class="ui-title">{{ message }}</h2>
				<div v-show="requirePassword" class="media-password-container">
					<ui-input
						v-model="password"
						autocomplete="new-password"
						autofocus
						label="Password"
						type="password"
						required
						@enter="onSubmitPassword(password)"
					/>
					<ui-button
						:disabled="!isPasswordSet"
						text="Submit"
						raised
						@click="onSubmitPassword(password)"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import UiButton from "lib/components/ui/Button";
import UiInput from "lib/components/ui/Input";

export default {
	name: "WebPlayerFeedback",
	components: {
		UiButton,
		UiInput
	},
	props: {
		onSubmitPassword: {
			type: Function,
			required: true
		}
	},
	data() {
		return {
			title: "",
			message: "",
			password: "",
			requirePassword: false
		};
	},
	computed: {
		isPasswordSet() {
			return this.password.length > 0;
		}
	},
	methods: {
		show(requirePassword, title, message) {
			this.requirePassword = requirePassword;
			this.title = title;
			this.message = message;
			this.password = ""; // clear password input
		}
	}
};
</script>

<style lang="scss" scoped>
.web-player-feedback {
	// set theme colors that is used in src/css/vuematerial/extensions/field.scss
	--rec-theme-background: #000;
	--rec-theme-on-primary: #aaa;
	--rec-theme-primary: #aaa;
	--rec-theme-icon: #aaa;
	--rec-theme-text: #aaa;

	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	.web-player-feedback__align {
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		height: 100%;
		.stream-loader {
			height: 18px;
		}
		.stream-feedback {
			color: #aaa;
			@media (max-width: 480px) {
				.ui-headline {
					font-size: 16px;
					line-height: 16px;
				}
				.ui-title {
					font-size: 14px;
				}
			}
		}
	}

	// needed due to IE11 not supporting CSS vars and css-vars-ponyfill only works on root scope
	/deep/ .md-field {
		&::before,
		&::after {
			background-color: #aaa;
		}
		label {
			color: #aaa;
		}
		input {
			color: #aaa;
		}
		button {
			.md-ripple-wave {
				background-color: #aaa;
			}
			svg {
				fill: #aaa;
			}
		}
	}

	/deep/ button:not(.md-input-action) {
		color: #aaa !important;
		background-color: #424242 !important;
		&:disabled {
			color: rgba(255, 255, 255, 0.3) !important;
			background-color: rgba(255, 255, 255, 0.12) !important;
		}
	}
}
</style>
